import service from "@/api/service";
import { GetRequest, RegisterRequest } from "@/api/movie-shop/request";
import { GetResponse, RegisterResponse } from "@/api/movie-shop/response";
import { CommonResponse } from "@/api/response";

/**
 * 公開動画情報取得APIをコールします。
 *
 * @return GetResponse
 */
export async function get(getRequest: GetRequest) {
  const response = await service.post("/get-movie-shop", getRequest);
  return response.data as GetResponse;
}

/**
 * 公開動画登録更新APIをコールします。
 *
 * @param registerRequest
 * @return RegisterResponse
 */
export async function register(registerRequest: RegisterRequest) {
  const response = await service.post("/regist-movie-shop", registerRequest);
  return response.data as RegisterResponse;
}
